/** Module store UI — EN / UK */

const EN = {
  title: 'Module store',
  subtitle: 'Extensions and quotas for your SCADA project',
  backToProject: 'Back to project',
  myModules: 'My modules',
  catalog: 'Catalog',
  plans: 'Plans & quotas',
  cart: 'Cart',
  cartEmpty: 'Your cart is empty',
  noConnectedModules: 'No add-on modules are active yet. Browse the catalog to extend your project.',
  addToCart: 'Add to cart',
  inCart: 'In cart',
  remove: 'Remove',
  connected: 'Connected',
  inPlan: 'Included in your plan',
  locked: 'Not connected',
  perMonth: '/ mo',
  onRequest: 'On request',
  highlights: 'Highlights',
  tutorial: 'How it works',
  openDetails: 'Details',
  dependencies: 'Also enables',
  openStore: 'Open module store',
  goToStore: 'Go to store',
  activateNow: 'Activate for project',
  submitRequest: 'Send request to support',
  requestCopied: 'Request copied — paste into email to support',
  activated: 'Modules activated. Returning to project…',
  activateFailed: 'Could not activate modules',
  planCompareTitle: 'Compare plans',
  planCompareModules: 'Add-on modules',
  planCompareQuotas: 'Included quotas',
  planCompareQuotaHint: 'Stations/users: add-on packs on top of plan. Events/trends retention: plan tier is fixed, store sells upgrades only. Trend tag count is separate from retention days.',
  quotaTagsSuffix: 'tags',
  quotaPlanTierLocked: 'Included with plan',
  quotaIncludedInPlan: 'included in plan',
  planCurrent: 'Current plan',
  quotaUnlimited: '∞',
  quotaPlanIncludes: 'plan',
  quotaDaysSuffix: 'days',
  quotaPriorityPrefix: 'up to',
  quotaExtensions: 'Quota extensions',
  quotaExtensionsHint: 'Stations and trend tags: add on top of plan. Event/trend retention and command priority: only upgrades above your plan tier (current tier shown greyed out).',
  quotaAlreadyUnlimited: 'Your plan already includes unlimited quota for this item.',
  selectQuota: 'Choose package',
  totalEstimate: 'Estimated total',
  items: 'items',
  clearCart: 'Clear cart',
  moduleNotConnected: 'This module is not enabled for the project.',
  supportEmailSubject: 'Module store request',
  projectCostTitle: 'Monthly estimate',
  projectCostSubtitle: 'Plan, add-ons and quota extensions',
  projectCostPlan: 'Plan',
  projectCostAddon: 'Add-on',
  projectCostQuota: 'Quota extension',
  projectCostDisclaimer: 'Indicative pricing for support quotes. Final billing may differ.',
  projectCostWithCart: 'After cart checkout',
  projectCostCartDelta: 'from cart',
  projectCostNoFee: 'No base fee',
  projectCostApprox: 'approx.',
  projectCostExpand: 'Show cost breakdown',
  projectCostCollapse: 'Hide breakdown',
  projectCostLoadFailed: 'Could not load billing estimate',
  purchaseInvoiceTitleStore: 'Confirm store checkout',
  purchaseInvoiceIntro: 'Prorated amount for the rest of this billing period will be charged now. The new monthly total applies from the next renewal.',
  purchaseInvoiceChargeNow: 'Charge now (prorated)',
  purchaseInvoiceMonthly: 'New monthly total',
  purchaseInvoiceChargeNowTotal: 'Total due now',
  purchaseInvoiceMonthlyRecurring: 'Monthly from next period',
  purchaseInvoiceMonthlyHint: 'project renewal date',
  purchaseInvoiceBalanceAfter: 'Balance after payment',
  purchaseInvoiceBalanceCurrent: 'Current balance: {amount}',
  purchaseInvoiceAvailable: 'Available: {amount}',
  purchaseInvoiceInsufficient: 'Insufficient balance. Top up your account or remove items.',
  purchaseInvoiceConfirm: 'Confirm and pay',
  purchaseInvoiceCancel: 'Cancel',
  themeDark: 'Dark',
  themeLight: 'Light',
  helpStoreTitle: 'Module store',
  helpStore: [
    'If a module depends on others, those are added to the cart as well, including nested dependencies.',
    'A superadmin confirms a prorated charge before save. Support saves immediately. Any other role only copies the request into an email; the project is not changed.',
    'When the cart is activated, every quota package left out of the cart is written back to the plan default, so a saved override for it is removed. Modules left out of the cart stay as they are.',
  ],
  categories: {
    visualization: 'Visualization',
    monitoring: 'Monitoring',
    integrations: 'Integrations',
    operations: 'Operations',
    support: 'Support',
  },
};

const UK = {
  title: 'Магазин модулів',
  subtitle: 'Розширення та квоти для вашого SCADA-проєкту',
  backToProject: 'Назад до проєкту',
  myModules: 'Мої модулі',
  catalog: 'Каталог',
  plans: 'Тарифи та квоти',
  cart: 'Кошик',
  cartEmpty: 'Кошик порожній',
  noConnectedModules: 'Ще немає активних модулів. Перегляньте каталог, щоб розширити проєкт.',
  addToCart: 'Додати в кошик',
  inCart: 'У кошику',
  remove: 'Прибрати',
  connected: 'Підключено',
  inPlan: 'Входить у ваш тариф',
  locked: 'Не підключено',
  perMonth: '/ міс',
  onRequest: 'За запитом',
  highlights: 'Можливості',
  tutorial: 'Як це працює',
  openDetails: 'Детальніше',
  dependencies: 'Також увімкне',
  openStore: 'Відкрити магазин модулів',
  goToStore: 'Перейти в магазин',
  activateNow: 'Активувати для проєкту',
  submitRequest: 'Надіслати запит у підтримку',
  requestCopied: 'Запит скопійовано — вставте в лист підтримці',
  activated: 'Модулі активовано. Повертаємось до проєкту…',
  activateFailed: 'Не вдалося активувати модулі',
  planCompareTitle: 'Порівняння тарифів',
  planCompareModules: 'Додаткові модулі',
  planCompareQuotas: 'Квоти в тарифі',
  planCompareQuotaHint: 'Станції/користувачі: допакети поверх тарифу. Події/тренди — дні зберігання: тариф фіксований, у магазині лише апгрейд. Кількість тегів трендів — окрема квота.',
  quotaTagsSuffix: 'тегів',
  quotaPlanTierLocked: 'Входить у тариф',
  quotaIncludedInPlan: 'входить у тариф',
  planCurrent: 'Поточний тариф',
  quotaUnlimited: '∞',
  quotaPlanIncludes: 'у тарифі',
  quotaDaysSuffix: 'дн.',
  quotaPriorityPrefix: 'до',
  quotaExtensions: 'Розширення квот',
  quotaExtensionsHint: 'Станції та теги трендів — доплата поверх тарифу. Події/тренди (дні) та пріоритет команд — лише апгрейд вище тарифу (поточний рівень сірим).',
  quotaAlreadyUnlimited: 'У вашому тарифі ця квота вже без обмежень.',
  selectQuota: 'Оберіть пакет',
  totalEstimate: 'Орієнтовна сума',
  items: 'поз.',
  clearCart: 'Очистити кошик',
  moduleNotConnected: 'Цей модуль не підключено до проєкту.',
  supportEmailSubject: 'Запит з магазину модулів',
  projectCostTitle: 'Орієнтовно на місяць',
  projectCostSubtitle: 'Тариф, докупки та розширення квот',
  projectCostPlan: 'Тариф',
  projectCostAddon: 'Докупка',
  projectCostQuota: 'Розширення квоти',
  projectCostDisclaimer: 'Орієнтовні ціни для заявки в підтримку. Фактичний рахунок може відрізнятися.',
  projectCostWithCart: 'Після оформлення кошика',
  projectCostCartDelta: 'з кошика',
  projectCostNoFee: 'Без базової плати',
  projectCostApprox: 'орієнт.',
  projectCostExpand: 'Показати розбивку вартості',
  projectCostCollapse: 'Приховати розбивку',
  projectCostLoadFailed: 'Не вдалося завантажити орієнтовну вартість',
  purchaseInvoiceTitleStore: 'Підтвердження покупки з кошика',
  purchaseInvoiceIntro: 'За решту поточного білінгового періоду спишеться пропорційна сума. Нова щомісячна вартість — з наступного продовження.',
  purchaseInvoiceChargeNow: 'Списати зараз (пропорційно)',
  purchaseInvoiceMonthly: 'Нова сума на місяць',
  purchaseInvoiceChargeNowTotal: 'До списання зараз',
  purchaseInvoiceMonthlyRecurring: 'Щомісяця з наступного періоду',
  purchaseInvoiceMonthlyHint: 'дата продовження проєкту',
  purchaseInvoiceBalanceAfter: 'Баланс після оплати',
  purchaseInvoiceBalanceCurrent: 'Поточний баланс: {amount}',
  purchaseInvoiceAvailable: 'Доступно: {amount}',
  purchaseInvoiceInsufficient: 'Недостатньо коштів. Поповніть баланс або приберіть позиції.',
  purchaseInvoiceConfirm: 'Підтвердити і сплатити',
  purchaseInvoiceCancel: 'Скасувати',
  themeDark: 'Темна',
  themeLight: 'Світла',
  helpStoreTitle: 'Магазин модулів',
  helpStore: [
    'Якщо модуль залежить від інших, вони теж потрапляють у кошик, включно з вкладеними залежностями.',
    'Суперадмін перед збереженням підтверджує пропорційне списання. Підтримка зберігає одразу. Будь-яка інша роль лише копіює запит у лист; проєкт не змінюється.',
    'Під час активації кошика кожна квота, якої в кошику немає, повертається до значення тарифу, тож збережене перевизначення для неї зникає. Модулі поза кошиком лишаються як були.',
  ],
  categories: {
    visualization: 'Візуалізація',
    monitoring: 'Моніторинг',
    integrations: 'Інтеграції',
    operations: 'Операції',
    support: 'Підтримка',
  },
};

export function getModuleStoreLocale(lang) {
  return lang === 'uk' ? UK : EN;
}
